import { render, staticRenderFns } from "./PaymentModalOldVersion.vue?vue&type=template&id=0662441a&scoped=true&"
import script from "./PaymentModalOldVersion.vue?vue&type=script&lang=js&"
export * from "./PaymentModalOldVersion.vue?vue&type=script&lang=js&"
import style0 from "./PaymentModalOldVersion.vue?vue&type=style&index=0&id=0662441a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662441a",
  null
  
)

export default component.exports